let queue = Promise.resolve();
let desiredDate;
let savedDate;
let pending = 0;

class FsgCartDeliveryDate extends HTMLElement {
  connectedCallback() {
    this.observer?.disconnect();
    this.observer = new MutationObserver(() => this.initialize());
    this.observer.observe(this, { childList: true, subtree: true });
    this.initialize();
  }

  initialize() {
    const input = this.querySelector('input');
    if (!input || input === this.input || !this.querySelector('.fsg-delivery-date__retry') ||
      !this.querySelector('.fsg-delivery-date__clear') || !this.querySelector('[role="status"]')) return;
    this.controller?.abort();
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.input = input;
    const today = new Date();
    this.input.min = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
    if (desiredDate === undefined) savedDate = desiredDate = this.input.value;
    this.input.value = desiredDate;
    const openPicker = (event) => {
      if (typeof this.input.showPicker !== 'function') return;
      try {
        this.input.showPicker();
        event.preventDefault();
      } catch {}
    };
    this.input.addEventListener('click', openPicker, options);
    this.input.addEventListener('keydown', (event) => {
      if (event.key === 'Tab' || event.key === 'Escape') return;
      if (event.key === 'Enter' || event.key === ' ') openPicker(event);
      event.preventDefault();
    }, options);
    for (const eventName of ['beforeinput', 'paste', 'drop']) {
      this.input.addEventListener(eventName, (event) => event.preventDefault(), options);
    }
    this.input.addEventListener('change', () => this.save(), options);
    this.querySelector('.fsg-delivery-date__clear').addEventListener('click', () => {
      this.input.value = '';
      this.save();
    }, options);
    this.querySelector('.fsg-delivery-date__retry').addEventListener('click', () => this.save(), options);
    this.renderStatus();
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.controller?.abort();
    this.input = null;
  }

  renderStatus() {
    if (!this.input) return;
    this.querySelector('[role="status"]').textContent = pending ? this.dataset.saving :
      desiredDate !== savedDate ? this.dataset.error : '';
    this.querySelector('.fsg-delivery-date__retry').hidden = pending > 0 || desiredDate === savedDate;
  }

  save() {
    if (!this.input.checkValidity()) {
      this.querySelector('[role="status"]').textContent = this.dataset.invalid;
      this.input.reportValidity();
      return Promise.resolve(false);
    }
    const value = this.input.value;
    desiredDate = value;
    pending++;
    this.renderStatus();
    const task = queue.then(async () => {
      try {
        const response = await fetch(this.dataset.updateUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { 'Requested delivery date': value } }),
        });
        if (!response.ok) throw new Error('Cart update failed');
        const cart = await response.json();
        if ((cart.attributes?.['Requested delivery date'] || '') !== value) throw new Error('Date not saved');
        savedDate = value;
        return true;
      } catch {
        return false;
      } finally {
        pending--;
        document.querySelectorAll('fsg-cart-delivery-date').forEach((element) => {
          element.renderStatus();
          if (!pending && desiredDate === savedDate) {
            element.querySelector('[role="status"]').textContent = value ? element.dataset.saved : element.dataset.removed;
          }
        });
      }
    });
    queue = task.then(() => undefined);
    return task;
  }
}

if (!customElements.get('fsg-cart-delivery-date')) {
  customElements.define('fsg-cart-delivery-date', FsgCartDeliveryDate);

  const guardCheckout = async (event) => {
    const element = document.querySelector('fsg-cart-delivery-date');
    if (!element?.input) return;
    const checkout = event.type === 'submit' ?
      event.target.id === 'cart-form' :
      event.target.closest?.('[name="checkout"], a[href*="/checkout"], shopify-accelerated-checkout-cart');
    if (!checkout) return;
    if (!element.input.checkValidity()) {
      event.preventDefault();
      event.stopImmediatePropagation();
      element.querySelector('details').open = true;
      element.input.reportValidity();
      return;
    }
    if (!pending && desiredDate === savedDate) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    await queue;
    if (desiredDate !== savedDate) {
      element.querySelector('details').open = true;
      element.renderStatus();
      element.input.focus();
      return;
    }
    if (event.type === 'submit') event.target.requestSubmit(event.submitter);
    else checkout.click();
  };
  document.addEventListener('click', guardCheckout, true);
  document.addEventListener('submit', guardCheckout, true);
}
